import { ActionList, Button, Card, LegacyCard, Popover } from "@shopify/polaris"
import { Tone } from "@shopify/polaris/build/ts/src/components/Badge"
import { useCallback, useEffect, useRef, useState } from "react"

export interface BadgeType {
  tone: Tone | undefined
  content: string
}
export interface RecommendApp {
  id: string
  name: string
  description: string
  badges: BadgeType[]
  img_url: string
  url: string
}

import { observer } from "mobx-react"
import { MenuHorizontalIcon, XIcon } from "polaris-enhance"

import CardTitle from "@/components/TitleGroup/CardTitle"
import stores from "@/stores"

import APPCard from "./APPCard"
import styles from "./index.module.scss"

const RecommendedCard = observer(() => {
  const [recommendedApps, setRecommendedApps] = useState<RecommendApp[]>([
    {
      id: "3",
      name: "ChatWILL: AI Chatbot & Live Chat",
      description:
        "Turn visitors into buyers with 24/7 order tracking and product suggestions.",
      badges: [
        {
          tone: "info",
          content: "Completely Free",
        },
      ],
      img_url:
        "https://cdn.shopify.com/app-store/listing_images/8efc27b294ac5ead3707607c5c0347de/icon/CKe0x5vk0pEDEAE=.png",
      url: "https://share.channelwill.com/app/40692e619e845cfYMm",
    },
    {
      id: "1",
      name: "SEOWILL - AI SEO Optimizer",
      description:
        "All-in-one SEO booster tools to increase traffic and sales, improve site speed and Google rankings",
      badges: [
        {
          tone: "info",
          content: "30% OFF",
        },
      ],
      img_url:
        "https://return-cdn.parcelpanel.net/return-test/682/c/20260104/1887817f48ae8724e2fa9480d1129c62.png",
      url: "https://share.seoant.com/app/11661cf03b54064q45",
    },
    {
      id: 4,
      name: "Wiz AI",
      description:
        "Wiz AI helps ecommerce brands recover carts, automate email flows, and run better campaigns.",
      badges: [
        {
          tone: "info",
          content: "Learn More",
        },
      ],
      img_url: "/images/WIZAI.jpeg",
      url: "https://apps.shopify.com/emailwiz?utm_source=ParcelWILL&utm_medium=app_collab&utm_campaign=ParcelWILLInApp",
    },
  ])
  const [popoverActive, setPopoverActive] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const hasReportedExposure = useRef(false)

  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    [],
  )

  // 检测移动端
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  useEffect(() => {
    // 获取推荐应用 hello 列表
    // api.getRecommendAppsHello().then(({ data }) => {
    //   setRecommendedApps(data.recommend_apps_hello)
    // })
  }, [])

  // const handleDismiss = useCallback(() => {
  //   setPopoverActive(false)
  //   // 添加你的 dismiss 逻辑
  //   console.log("Dismiss action triggered")
  //   stores.userInfoSore.closeBannerById(
  //     BannerEnum.CARD_DISMISSED_UNLOCK_TOP_APPS,
  //   )
  // }, [])

  // const handleViewMoreApps = useCallback(() => {
  //   setPopoverActive(false)
  //   navigator({ pathname: "/recommend-apps" })
  // }, [navigator])

  // 动态生成 popover 菜单项
  // const getPopoverItems = useCallback(() => {
  //   const items = []

  //   // 移动端时添加 ViewMoreApps 选项
  //   if (isMobile) {
  //     items.push({
  //       content: t("ViewMoreApps"),
  //       icon: AppsIcon,
  //       onAction: handleViewMoreApps,
  //     })
  //   }

  //   items.push({
  //     content: t("dismiss"),
  //     icon: XIcon,
  //     onAction: handleDismiss,
  //   })

  //   return items
  // }, [isMobile, t, handleViewMoreApps, handleDismiss])

  return (
    <LegacyCard sectioned>
      <CardTitle
        title={t("UnlockYourStoresPotentialWithTopAp")}
        titleRight={
          <div>
            <Popover
              active={popoverActive}
              activator={
                <div className={"flex mr-1"}>
                  <Button
                    variant={"tertiary"}
                    icon={MenuHorizontalIcon}
                    onClick={togglePopoverActive}
                  />
                </div>
              }
              onClose={togglePopoverActive}
            >
              <ActionList
                actionRole="menuitem"
                items={[
                  {
                    content: t("Dismiss"),
                    icon: XIcon,
                    onAction: () => {
                      togglePopoverActive()
                      stores.UserInfoStore.closeBanner(21, "is_show_other_app")
                    },
                  },
                ]}
              />
            </Popover>
          </div>
        }
      />
      <div
        className={styles.appsGrid} // 曝光事件名
      >
        {recommendedApps.map((app) => (
          <APPCard
            key={app.id}
            id={app.id}
            logo={app.img_url}
            title={app.name}
            description={app.description}
            link={app.url}
            badges={app.badges}
            hasHover
            onClick={() =>
              window.cwreport?.report("recommend_app_click", {
                recommend_app_id: app.id,
                recommend_app_name: app.name,
                position: "home_recommended_apps",
              })
            }
          />
        ))}
      </div>
    </LegacyCard>
  )
})

export { RecommendedCard }
